import { render, staticRenderFns } from "./MarketModal.vue?vue&type=template&id=7fdfbfe4&scoped=true"
import script from "./MarketModal.vue?vue&type=script&lang=js"
export * from "./MarketModal.vue?vue&type=script&lang=js"
import style0 from "./MarketModal.vue?vue&type=style&index=0&id=7fdfbfe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdfbfe4",
  null
  
)

export default component.exports